<template>
  <div>
    <el-card>
      <el-table :data="list" v-loading="loading">
        <el-table-column prop="id" label="ID" />
        <el-table-column prop="user.account" label="用户ID" />
        <el-table-column prop="promotion.title" label="活动" />
        <el-table-column prop="is_approved" label="是否通过">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.is_approved"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="handleApproved(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="批注">
          <template slot-scope="scope">
            <el-input v-model="scope.row.remark" @change="handleApproved(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" />
      </el-table>
      <pagination
        :total="total"
        :page.sync="page"
        :limit.sync="limit"
        @pagination="getList"
      />
    </el-card>
  </div>
</template>

<script>
import { getPromotionList,updatePromotionList } from '@/api/promotions'
import Pagination from '@/components/Pagination'

export default {
  components: { Pagination },
  data() {
    return {
      list: [],
      total: 0,
      page: 1,
      limit: 10,
      loading: true
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      getPromotionList({
        page: this.page,
        limit: this.limit
      }).then(response => {
        this.list = response.data.items
        this.total = response.data.total
        this.loading = false
      })
    },
    handleApproved(row) {
      updatePromotionList(row.id, { is_approved: row.is_approved,remark: row.remark }).then(() => {
        this.$message.success('更新成功')
      }).catch(() => {
        this.$message.error('更新失败')
      })
    }
  }
}
</script>
